import { getStylesObjFromCss } from "../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    root: {
      position: "relative",
    },

    profileImageContainer: {
      position: "absolute",
      top: "-40px",
      left: "-5px",
      width: "80px",
      height: "80px",
      borderRadius: "50%",
      backgroundColor: "white",
      padding: "4px",
      cursor: "pointer",
    },

    profileImage: {
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      objectFit: "cover",
    },

    profileDetailsContainer: {
      paddingTop: "5px",
      marginLeft: "0",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
    },

    communityTitle: {
      textAlign: "left",
      marginTop: "-2px",
      marginLeft: "85px",
      color: "#272522",
      minHeight: "35px",
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "normal",
    },

    headingSuffix: {
      marginTop: "0",
      fontSize: "12px",
      lineHeight: "normal",
    },

    poweredByText: {
      color: "#5C5C5C",
    },

    exlyText: {
      color: "#493ab1",
      fontWeight: 500,
    },

    memberCountContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      marginTop: "0",
      gap: "4px",
    },

    memberCount: {
      fontSize: "12px",
      color: "#4a5568",
      fontWeight: 400,
    },

    membershipBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      borderRadius: "999px",
      background: "linear-gradient(to right, #6fa8dc, #3d85c6)",
      color: "white",
      fontSize: "12px",
      fontWeight: 500,
      margin: "0",
      padding: "0px 8px 0px 6px",
      alignSelf: "flex-start",
    },

    badgeIcon: {
      width: "20px",
      height: "20px",
      borderRadius: "50%",
      border: "1px solid #166cd1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "10px",
      color: "#166cd1",
      background: "#fff",
    },

    badgeText: {
      padding: "2px 4px",
      fontSize: "11px",
    },
  },
  componentName: "Profile",
});
